import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PiTruckDuotone } from 'react-icons/pi';
import { MdClose } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import 'src/style/stagedashboard.css';

export default function StageRightSidebarV2({
  toggleRightSidebarTable,
  handleNavigation,
}) {
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const { stationData } = vehicleTrackingDataReducer;
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState('');

  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  const workflowStages =
    vehicleTrackingDataReducer.workflowStagesForVehicleTracking?.workflowStages;

  const renderWorkflowStages = (stages) => {
    let encounteredPending = false;

    return stages.map((stage) => {
      const disableButton = encounteredPending;

      // If current stage is "Pending", set the flag to disable subsequent buttons
      if (stage.workflow_status === 'Pending') {
        encounteredPending = true;
      }

      return (
        <div
          key={stage.workflow_stage_id}
          className="d-flex justify-content-between align-items-center p-2 border rounded mb-3"
        >
          <div>
            <span>{stage.workflow_stage_name}&nbsp;</span>
            <span className="bg-blue blue-pill text-md">
              {stage.workflow_status}
            </span>
          </div>
          <button
            className="btn btn-sm btn-dark"
            onClick={() => navigate(`/${stage.url}`)}
            disabled={disableButton}
          >
            Go to Stage
          </button>
        </div>
      );
    });
  };

  return (
    <div className="margin-top-10 left-padding right-padding div-flex-column rg-10">
      <div className="div-flex-row div-space-between div-align-center">
        <span className="text-xxl text-bold">Scan Incoming Vehicles</span>
        <MdClose size="18px" onClick={toggleRightSidebarTable} />
      </div>
      <div className="div-flex-column rg-10">
        <input
          className="form-input-section"
          type="text"
          name="search"
          value={searchText}
          onChange={handleChange}
          placeholder="Scan barcode or enter manually"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.stopPropagation();
              handleNavigation(searchText);
            }
          }}
        />
        <button
          className={`header-button theme-background-${themeColor}`}
          type="submit"
          onClick={() => handleNavigation(searchText)}
        >
          Get Stages
        </button>
        {workflowStages?.length > 0
          ? renderWorkflowStages(workflowStages)
          : null}
      </div>
      <hr />
      <div className="div-flex-column rg-10 div-scrollable-details history-div-height">
        <div className="div-flex-column">
          <span className="text-xl text-bold">History</span>
          <span className="text-md text-400">
            {stationData?.completedVehicleTracking?.count} Vehicles
          </span>
        </div>
        <div className="completed-vehicle div-flex-column">
          {stationData?.completedVehicleTracking?.count > 0 ? (
            stationData?.completedVehicleTracking?.data.map((data) => (
              <div
                key={data.vehicle_tracking_number}
                className="div-flex-column vehicle-tracking-card"
              >
                <div className="div-flex-row cg-10 div-align-center">
                  <div className="stage-icon-outline bg-green">
                    <PiTruckDuotone size="24px" />
                  </div>
                  <div className="div-flex-column">
                    <span className="text-md text-400">
                      {data.vehicle_tracking_code}
                    </span>
                    <span className="text-md text-400">
                      {data.vehicle_number}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <span className="text-md text-bold">No Entries</span>
          )}
        </div>
      </div>
    </div>
  );
}
